import { Container, Row, Col } from "reactstrap";
import cn from "classnames";
import styles from "./styles.module.scss";
import Link from "next/link";
import { IoMdCheckmark } from "react-icons/io";
import useCandidateSkills from "hooks/useCandidateSkills";

export const FeaturedJobOffers = ({
  className,
  title,
  heading,
  subtitle,
  cards,
  background,
  buttonLink,
  buttonTitle,
}) => {
  const allSkills = useCandidateSkills();
  return (
    <section
      className={cn(styles.FeaturedJobOffers, className, styles[background])}
    >
      <Container>
        {title && <h2 className={`${styles.title} ${heading}`}>{title}</h2>}
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}

        <Row className="mt-5">
          {cards?.map((card, idx) => (
            <Col xs={12} sm={6} md={6} lg={3} key={idx} className="mb-4">
              <div className={cn(styles.card, styles[card.variant])}>
                <div className={styles.imageWrapper}>
                  {card.image?.url && (
                    <img
                      src={card.image.url}
                      alt=""
                      className={styles.profileImage}
                    />
                  )}
                  <span className={styles.checkmark}>
                    <IoMdCheckmark />
                  </span>
                </div>
                <h3 className={styles.name}>{card.name}</h3>
                <p className={styles.position}>{card.position}</p>
                <div className={styles.skills}>
                  {Array.isArray(card.skills) &&
                    card.skills.map((skillId, i) => {
                      const skill = allSkills.find((s) => s.id === skillId);
                      return (
                        <span key={i} className={styles.skillBadge}>
                          {skill?.skill_name || "Unknown Skill"}
                        </span>
                      );
                    })}
                </div>
                <div
                  className={styles.description}
                  dangerouslySetInnerHTML={{ __html: card.description }}
                />
              </div>
            </Col>
          ))}
        </Row>
        {buttonLink && buttonTitle && (
          <div className="text-center mt-4">
            <Link href={buttonLink}>
              <a className="primaryBtn no-arrow m-0">{buttonTitle}</a>
            </Link>
          </div>
        )}
      </Container>
    </section>
  );
};

export default FeaturedJobOffers;
